import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noOptionsMessageNonFinal: {
		id: 'polaris-common.fields.connection.edit.no-options-message.no-options-message-non-final',
		defaultMessage: 'No results found',
		description: 'Message to show when no issues match the search query',
	},
});
